import { render, staticRenderFns } from "./subtab.vue?vue&type=template&id=577e2bef&"
import script from "./subtab.vue?vue&type=script&lang=js&"
export * from "./subtab.vue?vue&type=script&lang=js&"
import style0 from "./subtab.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('577e2bef')) {
      api.createRecord('577e2bef', component.options)
    } else {
      api.reload('577e2bef', component.options)
    }
    module.hot.accept("./subtab.vue?vue&type=template&id=577e2bef&", function () {
      api.rerender('577e2bef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/subtab/subtab.vue"
export default component.exports